module.exports = __webpack_public_path__ + "static/media/logo.22c6fcec.png";